import React from 'react';
import styled from '@emotion/styled';

import { H3, H4 } from 'ds/components/typography';
import CheckCircleIcon from 'assets/svg/v-circle.svg';
import Tabu from 'components/tabu';

import {
  TabuAdditionalInformation,
  TabuRegistrationSummaryData,
  TabuStages,
} from 'store/state/selectors/insights/summaryTypes';
import mobileAppConfig from 'react-native/config';
import config from 'config';


const Block = styled.div`
  padding-bottom: 24px;
`;

const StatusBlock = styled(Block)`
  position: relative;

  &:not(:last-of-type):before {
    content: '';
    position: absolute;
    right: 7px;
    width: 2px;
    top: 20px;
    height: calc(100% - 16px);
    background-color: ${({ theme }) => theme.colors.neutrals.grey2};
  }
`;

const TabuWrapper = styled.div`
  ${({ theme: { spacing } }) => `
    margin-bottom: ${spacing(6)};
  `}
`;

const StatusWrapper = styled.div`
  display: flex;

  > svg, span {
    flex-shrink: 0;
    margin-left: 12px;
  }

  > svg {
    margin-top: ${({ theme }) => theme.spacing(0.5)};
  }

  > span {
    width: 16px;
    height: 16px;
    border: 1px solid ${({ theme }) => theme.colors.neutrals.grey2};
    border-radius: ${({ theme }) => theme.borderRadius.round};
  }
`;


export const TabuRegistrationSummary: React.FunctionComponent<{ data: TabuRegistrationSummaryData }> = ({ data }) => (
  <div>
    {mobileAppConfig.hideNesachTabu || config.hideNesachTabu ? null : (
      <TabuWrapper>
        <Tabu source="insight" />
      </TabuWrapper>
    )}
    <H3>
      {data.registrationImportance.header}
    </H3>
    <Block>
      {data.registrationImportance.content.p1}
    </Block>
    <Block>
      {data.registrationImportance.content.p2}
    </Block>

    <H3>
      {data.status.header}
    </H3>
    <H4>
      {data.status.completedStages.str}
    </H4>

    <StatusComponent stages={data.status.stages} completedStages={data.status.completedStages.key} />

    <AdditionalInformationComponent additionalInformation={data.status.additionalInformation} />
    <Block>
      {data.problematicRegistrationAreaAddition}
    </Block>
  </div>
);

const AdditionalInformationComponent: React.FC<{ additionalInformation: TabuAdditionalInformation }> = ({
  additionalInformation: {
    header: mainHeader,
    price,
    mortgage,
    buySellProcess,
    transferenceCost,
  },
}) => (
  <div>
    <H3>{mainHeader}</H3>
    {[ price, mortgage, buySellProcess, transferenceCost ].map(({ header, content }, idx) => (
      <Block key={idx}>
        <H3>
          {header}
        </H3>
        <div>
          {content}
        </div>
      </Block>
    ))}
  </div>
);

const StatusComponent: React.FC<{ stages: TabuStages, completedStages: number }> = ({
  stages: {
    parcellation,
    condo,
    tabu,
  },
  completedStages,
}) => (
  <div>
    {[ parcellation, condo, tabu ].map(({ header, content }, idx) => (
      <StatusBlock key={idx}>
        <StatusWrapper>
          {idx < completedStages ? <CheckCircleIcon /> : <span />}
          <div>
            <H3>
              {header}
            </H3>
            <div>
              {content}
            </div>
          </div>
        </StatusWrapper>
      </StatusBlock>
    ))}
  </div>
);
